import { render, staticRenderFns } from "./LessonDashboard.vue?vue&type=template&id=7268a17f&scoped=true"
import script from "./LessonDashboard.vue?vue&type=script&lang=js"
export * from "./LessonDashboard.vue?vue&type=script&lang=js"
import style0 from "./LessonDashboard.vue?vue&type=style&index=0&id=7268a17f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7268a17f",
  null
  
)

export default component.exports